import React, { useEffect, useState, useContext } from "react";
import { Modal, Form, Select, Space, Row, Input, Button } from "antd";
import { FolderFilled, FolderTwoTone } from "@ant-design/icons";
import { useAtom } from "jotai";
import { visibleModalAsignarCarpetaAtom, documentoSeleccionadoAtom, enviosAtom, carpetasAtom } from "pages/seguimiento/listar/ListarSeguimientoStore";
import { EnvioService } from "services/EnvioService";




  const ModalAsignarCarpeta = () => {
  const [visibleModalAsignarCarpeta, setVisibleModalAsignarCarpeta] = useAtom(visibleModalAsignarCarpetaAtom);
  const { Option } = Select;
  const [carpetas, setCarpetas] = useAtom(carpetasAtom);
  const [envios, setEnvios] = useAtom(enviosAtom);
  const [documentoSeleccionado,setDocumentoSeleccionado ] = useAtom(documentoSeleccionadoAtom );
  const [frmCarpeta] = Form.useForm();


  useEffect(() => {
    const cargarDatos = async () => {
 
      
      const tempcap = carpetas.find(item=> item.id==documentoSeleccionado?.carpeta?.id)

      frmCarpeta.setFieldsValue({
        carpetaId: tempcap?.id
      });

    };
  
    cargarDatos();

  }, [documentoSeleccionado]);



  const onFinishCarpeta = async (documentoCarpeta) => {
    //console.log("contratoS:", carpetaDescripcion.carpeta.descripcion);
    documentoCarpeta.id = documentoSeleccionado.id;
    await EnvioService.asignarCarpeta(documentoCarpeta);
    if(envios.length>0){
      console.log("se esta modificando");
      const _documentos = [...envios]; //siempre se debe generar un nuevo array
      const indice = envios.findIndex((documento) => documento.id === documentoSeleccionado.id);
      const detalleModificar = envios[indice];
      const detalleModificado = {
          ...detalleModificar,
          carpeta: {
              id:documentoCarpeta.carpetaId,
              descripcion:documentoCarpeta.carpetaDescripcion,
              ruta: carpetas.find(item=> item.id==documentoCarpeta.carpetaId)?.ruta
          }
      }
      _documentos.splice(indice, 1, detalleModificado);
      setEnvios(_documentos);
    }
    
    setVisibleModalAsignarCarpeta(false);
  };
  const onChangeSelectCarpeta = (value, option) => {
    frmCarpeta.setFieldsValue({ carpetaDescripcion: option.descripcion });
  };
  const onLimpiarDatos = () => {
    frmCarpeta.setFieldsValue({
      carpetaId: "",
      carpetaDescripcion: "",
    });
    setDocumentoSeleccionado(null);

  };

  const onClickBtnCancelar = () => {
    setVisibleModalAsignarCarpeta(false);

  };

  return (
    <Modal
      title={<div>Asignar Carpeta a:</div>}
      //title={documento}
      visible={visibleModalAsignarCarpeta}
      onCancel={onClickBtnCancelar}
      footer={null}
      forceRender 
      afterClose={onLimpiarDatos}
    >
      <Form
        onFinish={onFinishCarpeta}
        form={frmCarpeta}
        //initialValues={{ carpetaId: documento.carpeta.id }}
      >
        <Form.Item
          label="Carpeta"
          name="carpetaId"
          rules={[
            {
              required: true,
              message: "Seleccione la Carpeta.",
            },
          ]}
        >
          <Select
            onChange={onChangeSelectCarpeta}
            optionLabelProp="label"
            placeholder="Seleccione la carpeta"
          >
            {carpetas.length > 0 &&
              carpetas.map((carpeta) => {
                return (
                  <Option
                    key={carpeta.id}
                    value={carpeta.id}
                    label={
                      <div>
                        <FolderTwoTone
                          style={{ fontSize: "20px", color: "#F7D358" }}
                          twoToneColor="#F7D358"
                        />{" "}
                        {carpeta.ruta}
                      </div>
                    }
                    descripcion={carpeta.descripcion}
                  >
                    <Space size={carpeta.nivel * 10}>
                      <span></span>
                      <span>
                        {carpeta.nivel === 0 ? (
                          <FolderFilled
                            style={{ fontSize: "20px", color: "#F7D358" }}
                          />
                        ) : (
                          <FolderTwoTone
                            style={{ fontSize: "18px", color: "#F7D358" }}
                            twoToneColor="#F7D358"
                          />
                        )}{" "}
                        {carpeta.descripcion}
                      </span>
                    </Space>
                  </Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item name="carpetaDescripcion" noStyle>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item>
          <Row justify="end">
            <Button type="primary" htmlType="submit">
              Guardar
            </Button>
          </Row>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default ModalAsignarCarpeta;
